import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Pill — colored status / count / tag chip.
 *
 * Use for role chips, count badges, filter chips, and feature flags.
 * For the toggle-style boolean case use `<Switch>` instead.
 *
 * @example
 *   <Pill variant="accent">admin</Pill>
 *   <Pill variant="success">active</Pill>
 *   <Pill variant="neutral" onDismiss={() => clearFilter()}>open</Pill>
 *   <Pill icon={<CheckIcon />}>verified</Pill>
 */
export function Pill({ variant = 'neutral', size = 'md', icon, onDismiss, dismissLabel, children, }) {
    const classes = ['osd-pill', `osd-pill--${variant}`, `osd-pill--${size}`].join(' ');
    const dismissAria = dismissLabel ?? (typeof children === 'string' ? `Remove ${children}` : 'Remove');
    return (_jsxs("span", { className: classes, children: [icon !== undefined && _jsx("span", { className: "osd-pill__icon", children: icon }), _jsx("span", { className: "osd-pill__label", children: children }), onDismiss !== undefined && (_jsx("button", { type: "button", className: "osd-pill__dismiss", "aria-label": dismissAria, onClick: onDismiss, children: "\u00D7" }))] }));
}
//# sourceMappingURL=Pill.js.map